module.exports = __webpack_public_path__ + "img/safer_from_cyberattacks_Light.41a26738.svg";